import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import Root from 'src/client/Root';
import moment from 'moment';
import 'moment/locale/ko';
moment.locale('ko');

ReactDOM.render(
  <BrowserRouter>
    <Root />
  </BrowserRouter>,
  document.getElementById('root')
);

serviceWorker.unregister();
